module.exports = __webpack_public_path__ + "media/images/products/title-texture-8c4d91015f82620b3905ffc0202570f0.png";